'use client';

import React from 'react';
import type { DialogProps } from '../Dialog';
import { Button } from '../../Button/Button';
import { cn } from '../../../utils/cn/cn';

export type DialogHeaderProps = React.HTMLAttributes<HTMLDivElement> &
  Pick<DialogProps, 'onClose'> & {
    /** Callback fired when the header requests to return to the previous page */
    onBack?: () => void;
    ariaLabelBack?: string;
    ariaLabelClose?: string;
  };

/**
 * The dialog header container
 */
const DialogHeaderBase = ({
  children,
  className,
  onBack,
  onClose,
  ariaLabelBack,
  ariaLabelClose,
  ...props
}: DialogHeaderProps) => (
  <header
    {...props}
    className={cn(
      'bg-color-background-base border-color-grey z-dialog-sticky flex w-full items-center justify-between border-b px-2 sm:min-h-[64px]',
      className,
    )}
  >
    {onBack && (
      <Button
        variant="icon-flat"
        onClick={(e) => {
          // prevent submitting forms
          e.preventDefault();
          onBack();
        }}
        className="bg-color-transparent h-4 w-4 rounded-sm border-0 p-0"
        aria-label={ariaLabelBack}
      >
        <span className="icon-emp-arrow-medium-left h-4 w-4" />
      </Button>
    )}
    <span className="lg:text-size-headline-xl text-size-headline-base">{children}</span>
    <Button
      variant="icon-flat"
      onClick={(e) => {
        // prevent submitting forms
        e.preventDefault();
        onClose();
      }}
      className="bg-color-transparent h-4 w-4 rounded-sm border-0 p-0"
      size="base"
      aria-label={ariaLabelClose}
    >
      <span className="icon-emp-cancel h-4 w-4" />
    </Button>
  </header>
);

DialogHeaderBase.displayName = 'DialogHeader';

export { DialogHeaderBase };
